<template>
  <div class="flex w-full flex-col items-center px-5 lg:px-10">
    <div
      class="flex w-full max-w-396.75 flex-col items-center border-b border-gray"
    >
      <component
        :is="hasChildren ? 'button' : 'div'"
        :type="hasChildren ? 'button' : undefined"
        @click="hasChildren ? handleOpenMenu() : undefined"
        :class="[
          'w-full pb-3.5 xl:pb-3.75',
          hasChildren ? 'cursor-pointer' : 'cursor-default',
        ]"
        :aria-label="
          hasChildren
            ? title + ' ' + (isMenuOpen ? 'zavřít menu' : 'otevřít menu')
            : undefined
        "
      >
        <div class="relative flex w-full items-center justify-center">
          <h1
            class="bp1680:w-[1326px] mx-auto w-[241px] text-center font-header text-[26px] leading-[115%] break-words sm:w-[309px] md:w-[603px] md:text-4.5xl md:leading-[105%] lg:w-[780px] xl:w-[1126px] xl:text-6xl 2xl:w-[1326px] 2xl:text-[70px]/[100%]"
          >
            {{ title }}
          </h1>

          <div
            v-if="hasChildren"
            class="pointer-events-none absolute top-1/2 right-0 flex h-6.5 w-6.5 shrink-0 -translate-y-1/2 items-center justify-center rounded-full bg-black md:h-7.5 md:w-7.5 xl:h-11 xl:w-11"
          >
            <ChevronIcon
              :class="[
                'block h-4 w-4 shrink-0 origin-center text-white transition-transform duration-400 ease-in-out md:h-5 md:w-5 xl:h-7 xl:w-7',
                isMenuOpen
                  ? '-translate-y-[1px] rotate-180 md:-translate-y-[1.5px] xl:-translate-y-[2px]'
                  : 'translate-y-[1px] rotate-0 md:translate-y-[1.5px] xl:translate-y-[2px]',
              ]"
            />
          </div>
        </div>
      </component>

      <div
        v-if="hasChildren"
        :class="[
          'grid w-69.25 transition-all duration-400 ease-in-out min-[479px]:w-90.75 md:w-151.25 lg:w-154 xl:w-185! 2xl:w-215.75!',
          isMenuOpen
            ? 'grid-rows-[1fr] opacity-100'
            : 'grid-rows-[0fr] opacity-0',
        ]"
      >
        <div class="flex flex-col overflow-hidden">
          <div
            class="mt-11.25 flex flex-col border-gray pb-12.5 first:border-t md:mt-12.5 lg:mt-17.5"
          >
            <NuxtLink
              v-for="link in childrenLinks"
              :key="link.id"
              :to="localePath(link.menu_url || link.href || link.url || '/')"
              class="border-b border-gray py-2.5 text-base leading-[115%] transition-colors duration-300 hover:text-gray-medium md:text-xl xl:py-3 xl:text-[26px]"
              :aria-label="link.title || link.name || link.label"
            >
              {{ link.title || link.name || link.label }}
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ChildrenLink } from '~/types'

interface Props {
  title: string
  childrenLinks?: ChildrenLink[] | undefined
}

const props = defineProps<Props>()
const localePath = useLocalePath()

const isMenuOpen = ref(false)

const hasChildren = computed(() => (props.childrenLinks?.length ?? 0) > 0)

const handleOpenMenu = () => {
  if (!hasChildren.value) return
  isMenuOpen.value = !isMenuOpen.value
}
</script>
